import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=3c66a67f&scoped=true"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"
import style0 from "./BaseView.vue?vue&type=style&index=0&id=3c66a67f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66a67f",
  null
  
)

export default component.exports